import { Component, OnInit } from '@angular/core';
import {
  AppState,
  BrandsActionTypes,
  MyCollectionActionTypes,
  MyNotificationsActionTypes,
  selectProfile,
} from '@app/core/ngrx';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { User } from '@app/core/models';
import { take } from 'rxjs/operators';
/**
 * MyCollectionComponent
 */
@Component({
  selector: 'ecp-my-collection',
  templateUrl: './my-collection.component.html',
  styleUrls: ['./my-collection.component.scss'],
})
export class MyCollectionComponent implements OnInit {
  // @select(['user', 'profile'])
  user$: Observable<User>;
  /**
   * loading$
   */
  // @select(['mycollection', 'pending'])
  loading$: Observable<boolean>;
  /**
   * constructor
   */
  constructor(private store: Store<AppState>) {}
  /**
   * ngOnInit
   */
  ngOnInit() {
    this.user$ = this.store.pipe(select(selectProfile));
    this.loading$ = this.store.pipe(select(state => state.myCollection.pending));
    // we need to get the VisionWeb token from the user's profile
    this.user$.subscribe(user => {
      // once we have the token we can call the other services
      if (user.token) {
        window.localStorage.setItem('token', user.token);
        this.store.dispatch({ type: BrandsActionTypes.LOAD_BRANDS, programKey: user.program.programKey });
        this.store.dispatch({
          type: MyCollectionActionTypes.LOAD_MY_COLLECTION,
        });
      }
    });
  }
}
